import React, { useState, useEffect } from 'react';
import { getAlert, createAlert, updateAlert, deleteAlert, toggleAlert, getNotificheLog, getNumeriSoprasoglia, testAlert, getRuote } from '../services/api';

const Alert = () => {
  const [alerts, setAlerts] = useState([]);
  const [ruote, setRuote] = useState([]);
  const [notifiche, setNotifiche] = useState([]);
  const [soprasoglia, setSoprasoglia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingAlert, setEditingAlert] = useState(null);
  const [message, setMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('alert');

  // Form state
  const [nome, setNome] = useState('');
  const [ruotaId, setRuotaId] = useState('');
  const [soglia, setSoglia] = useState(100);
  const [numeriInput, setNumeriInput] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [alertRes, ruoteRes, notificheRes, soprasogliaRes] = await Promise.all([
        getAlert(),
        getRuote(),
        getNotificheLog(50),
        getNumeriSoprasoglia()
      ]);
      setAlerts(alertRes.data);
      setRuote(ruoteRes.data);
      setNotifiche(notificheRes.data);
      setSoprasoglia(soprasogliaRes.data);
    } catch (err) {
      console.error('Errore caricamento dati:', err);
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 5000);
  };

  const resetForm = () => {
    setNome('');
    setRuotaId('');
    setSoglia(100);
    setNumeriInput('');
    setEditingAlert(null);
    setShowForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const numeri = numeriInput
      ? numeriInput.split(',').map(n => parseInt(n.trim())).filter(n => n >= 1 && n <= 90)
      : null;

    const data = {
      nome: nome || `Alert soglia ${soglia}`,
      ruota_id: ruotaId ? parseInt(ruotaId) : null,
      soglia: parseInt(soglia),
      numeri: numeri && numeri.length > 0 ? numeri : null,
      attivo: true
    };

    try {
      if (editingAlert) {
        await updateAlert(editingAlert.id, data);
        showMessage('Alert aggiornato');
      } else {
        await createAlert(data);
        showMessage('Alert creato');
      }
      resetForm();
      loadData();
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore salvataggio', 'error');
    }
  };

  const handleEdit = (alert) => {
    setEditingAlert(alert);
    setNome(alert.nome || '');
    setRuotaId(alert.ruota_id ? alert.ruota_id.toString() : '');
    setSoglia(alert.soglia);
    setNumeriInput(alert.numeri ? alert.numeri.join(', ') : '');
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminare questo alert?')) return;

    try {
      await deleteAlert(id);
      showMessage('Alert eliminato');
      loadData();
    } catch (err) {
      showMessage('Errore eliminazione', 'error');
    }
  };

  const handleToggle = async (id) => {
    try {
      await toggleAlert(id);
      loadData();
    } catch (err) {
      showMessage('Errore cambio stato', 'error');
    }
  };

  const handleTest = async () => {
    try {
      const res = await testAlert();
      showMessage(`Test completato: ${res.data.numeri_soprasoglia} numeri soprasoglia, ${res.data.notifiche_inviate} notifiche inviate`);
      loadData();
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore test', 'error');
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <h2>Alert Ritardi</h2>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button className="btn btn-secondary" onClick={handleTest}>
            Test Notifica
          </button>
          <button className="btn btn-primary" onClick={() => { resetForm(); setShowForm(!showForm); }}>
            {showForm ? 'Chiudi' : 'Nuovo Alert'}
          </button>
        </div>
      </div>

      {message && (
        <div className={'alert alert-' + (message.type === 'error' ? 'error' : 'success')}>
          {message.text}
        </div>
      )}

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px' }}>
        <button
          className={activeTab === 'alert' ? 'btn btn-primary' : 'btn btn-secondary'}
          onClick={() => setActiveTab('alert')}
        >
          I miei Alert ({alerts.length})
        </button>
        <button
          className={activeTab === 'soprasoglia' ? 'btn btn-primary' : 'btn btn-secondary'}
          onClick={() => setActiveTab('soprasoglia')}
        >
          Soprasoglia ({soprasoglia.length})
        </button>
        <button
          className={activeTab === 'storico' ? 'btn btn-primary' : 'btn btn-secondary'}
          onClick={() => setActiveTab('storico')}
        >
          Storico Notifiche
        </button>
      </div>

      {/* Form nuovo/modifica alert */}
      {showForm && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3 className="card-title">{editingAlert ? 'Modifica Alert' : 'Nuovo Alert'}</h3>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-2" style={{ gap: '20px' }}>
              <div className="form-group">
                <label className="form-label">Nome Alert</label>
                <input
                  type="text"
                  className="form-input"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Es: Ritardi importanti"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Ruota (vuoto = tutte)</label>
                <select
                  className="form-select"
                  value={ruotaId}
                  onChange={(e) => setRuotaId(e.target.value)}
                >
                  <option value="">Tutte le ruote</option>
                  {ruote.map(r => (
                    <option key={r.id} value={r.id}>{r.nome}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid grid-2" style={{ gap: '20px', marginTop: '15px' }}>
              <div className="form-group">
                <label className="form-label">Soglia Ritardo</label>
                <input
                  type="number"
                  className="form-input"
                  value={soglia}
                  onChange={(e) => setSoglia(e.target.value)}
                  min="1"
                  max="500"
                  required
                />
                <small style={{ color: '#718096' }}>Notifica quando ritardo supera questo valore</small>
              </div>

              <div className="form-group">
                <label className="form-label">Numeri da monitorare (vuoto = tutti)</label>
                <input
                  type="text"
                  className="form-input"
                  value={numeriInput}
                  onChange={(e) => setNumeriInput(e.target.value)}
                  placeholder="Es: 7, 23, 45 (vuoto = tutti)"
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button type="submit" className="btn btn-success">
                {editingAlert ? 'Aggiorna' : 'Crea Alert'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={resetForm}>
                Annulla
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Tab: I miei Alert */}
      {activeTab === 'alert' && (
        <div className="card">
          <h3 className="card-title">I miei Alert</h3>

          {alerts.length === 0 ? (
            <p style={{ color: '#718096', textAlign: 'center', padding: '20px' }}>
              Nessun alert configurato. Crea il tuo primo alert per ricevere notifiche sui ritardi.
            </p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Ruota</th>
                  <th>Soglia</th>
                  <th>Numeri</th>
                  <th>Stato</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {alerts.map(alert => (
                  <tr key={alert.id}>
                    <td>{alert.nome}</td>
                    <td>
                      <span className="ruota-badge">
                        {alert.ruota_nome || 'Tutte'}
                      </span>
                    </td>
                    <td>
                      <strong style={{ color: '#2c5282' }}>{alert.soglia}</strong>
                    </td>
                    <td>
                      {alert.numeri ? (
                        alert.numeri.slice(0, 5).map(n => (
                          <span key={n} className="numero-ball small">{n}</span>
                        ))
                      ) : (
                        <span style={{ color: '#718096' }}>Tutti</span>
                      )}
                      {alert.numeri && alert.numeri.length > 5 && (
                        <span style={{ color: '#718096' }}> +{alert.numeri.length - 5}</span>
                      )}
                    </td>
                    <td>
                      <span
                        className="ruota-badge"
                        style={{
                          background: alert.attivo ? '#c6f6d5' : '#fed7d7',
                          color: alert.attivo ? '#22543d' : '#822727',
                          cursor: 'pointer'
                        }}
                        onClick={() => handleToggle(alert.id)}
                      >
                        {alert.attivo ? 'ATTIVO' : 'DISATTIVO'}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '5px' }}>
                        <button
                          className="btn btn-primary"
                          style={{ padding: '3px 8px', fontSize: '0.75rem' }}
                          onClick={() => handleEdit(alert)}
                        >
                          Modifica
                        </button>
                        <button
                          className="btn btn-danger"
                          style={{ padding: '3px 8px', fontSize: '0.75rem' }}
                          onClick={() => handleDelete(alert.id)}
                        >
                          Elimina
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tab: Numeri soprasoglia */}
      {activeTab === 'soprasoglia' && (
        <div className="card">
          <h3 className="card-title">Numeri Attualmente Soprasoglia</h3>

          {soprasoglia.length === 0 ? (
            <p style={{ color: '#718096', textAlign: 'center', padding: '20px' }}>
              Nessun numero soprasoglia per i tuoi alert attivi.
            </p>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '15px' }}>
              {soprasoglia.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    padding: '15px',
                    background: item.ritardo >= item.soglia * 1.5 ? '#fed7d7' : '#fef3c7',
                    borderRadius: '8px',
                    border: '1px solid ' + (item.ritardo >= item.soglia * 1.5 ? '#fc8181' : '#f6ad55')
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span className="numero-ball" style={{ fontSize: '1.2rem', width: '45px', height: '45px', lineHeight: '45px' }}>
                      {item.numero}
                    </span>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontWeight: 'bold', color: '#822727', fontSize: '1.1rem' }}>
                        {item.ritardo} estrazioni
                      </div>
                      <div style={{ fontSize: '0.85rem', color: '#718096' }}>
                        soglia: {item.soglia}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    <span className="ruota-badge">{item.ruota_nome}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Tab: Storico notifiche */}
      {activeTab === 'storico' && (
        <div className="card">
          <h3 className="card-title">Storico Notifiche Inviate</h3>

          {notifiche.length === 0 ? (
            <p style={{ color: '#718096', textAlign: 'center', padding: '20px' }}>
              Nessuna notifica inviata ancora.
            </p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Data/Ora</th>
                  <th>Numero</th>
                  <th>Ruota</th>
                  <th>Ritardo</th>
                </tr>
              </thead>
              <tbody>
                {notifiche.map(n => (
                  <tr key={n.id}>
                    <td>{new Date(n.notificato_at).toLocaleString('it-IT')}</td>
                    <td>
                      <span className="numero-ball">{n.numero}</span>
                    </td>
                    <td>
                      <span className="ruota-badge">{n.ruota_nome}</span>
                    </td>
                    <td>
                      <strong style={{ color: '#822727' }}>{n.ritardo}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      <style>{`
        .grid-2 {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 768px) {
          .grid-2 {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default Alert;
